import { createPromiseClient } from '@bufbuild/connect';
import { ConnectTransportOptions } from '@bufbuild/connect-web';
import {
  ResponseStatusCodeFunction,
  lmsTransport,
  lmsTransportWithLogoutHandler,
} from './transports';
import { LmsAssessmentStudentReportsAPIServiceV1 } from '@protos/learning_management/lms.assessment.student.apis_connect';

export const LmsAssessmentStudentAPIServiceV1Client = createPromiseClient(
  LmsAssessmentStudentReportsAPIServiceV1,
  lmsTransport
);

export const useLmsAssessmentStudentReportsAPIServiceV1ClientWithStatusCodeHandler =
  (
    options: Partial<ConnectTransportOptions>,
    responseStatusCodeFunction: ResponseStatusCodeFunction
  ) =>
    createPromiseClient(
      LmsAssessmentStudentReportsAPIServiceV1,
      lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
    );
